import type { PrescreenFieldKeys, PrescreenFields } from './pages/prescreen-form'
import type { PrescreenMessageData } from './types'

import set from 'lodash/set'

import { PRESCREEN_FIELDS } from 'constant'

export const parsePrescreenFormData = (prescreenFormData: PrescreenFields) =>
  Object.keys(PRESCREEN_FIELDS).reduce((result, key) => {
    const prescreenKey = key as PrescreenFieldKeys
    const prescreenAnswer = prescreenFormData[prescreenKey]

    if (prescreenAnswer) {
      const answerSheetData = {
        question: PRESCREEN_FIELDS[prescreenKey].label,
        answer: prescreenAnswer,
      }
      if (!result.answerSheet) {
        set(result, 'answerSheet', [answerSheetData])
      } else {
        result.answerSheet?.push(answerSheetData)
      }
    }
    return result
  }, {} as PrescreenMessageData)
